import { render, staticRenderFns } from "./custConvertChannelSourceNewListCmr.vue?vue&type=template&id=627c3c55&scoped=true"
import script from "./custConvertChannelSourceNewListCmr.vue?vue&type=script&lang=js"
export * from "./custConvertChannelSourceNewListCmr.vue?vue&type=script&lang=js"
import style0 from "./custConvertChannelSourceNewListCmr.vue?vue&type=style&index=0&id=627c3c55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c3c55",
  null
  
)

export default component.exports